module.exports = __webpack_public_path__ + "media/packs/images/state/small/customs-3dee2da35b0a3b60120c87f8518a4b75.svg";